import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { report } from '_c/business/api/report';
import store, { AllModuleState } from '@/store';
// 记录展示时长
let startTime = 0;
// 记录总时长
let allStartTime = 0;
// groupId,channelId
let cid: string;
let gid: string;
// 展示计时器容器
let openTimer: NodeJS.Timeout | null = null;
// 总时长计时器容器
let allTimer: NodeJS.Timeout | null = null;
// 记录页面是否聚焦
let isBlur = false;
let isHidden = false;
export default function (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  // 获取gid与cid
  getGidAndCid();
  window.onblur = () => {
    isBlur = true;
    hideChangeListener();
  };
  window.onfocus = () => {
    isBlur = false;
    hideChangeListener();
  };
  const fromPrimaryPath = from.path.split('/')[1];
  const toPrimaryPath = to.path.split('/')[1];
  if (fromPrimaryPath !== 'main' && toPrimaryPath === 'main') {
    // 从其他页面进入main页面开启定时器
    startTime = Date.now();
    allStartTime = Date.now();
    // 设置定时器定时上报展示时长
    openTimer = setInterval(() => {
      onReportOpenHandler(cid, gid);
    }, 10000);
    // 设置定时器定时上报总时长
    allTimer = setInterval(() => {
      onReportAllHandler(cid, gid);
    }, 10000);
    // 监听页面隐藏显示事件
    document.addEventListener('visibilitychange', hideChangeListener);
    // 监听页面关闭事件
    document.addEventListener('onbeforeunload ', closeChangeListener);
    next();
  } else if (fromPrimaryPath === 'main' && toPrimaryPath !== 'main') {
    // 离开main页面前往其他页面时上报数据并清除定时器
    clearInterval(Number(openTimer));
    clearInterval(Number(allTimer));
    // 上报
    onReportOpenHandler(cid, gid);
    onReportAllHandler(cid, gid);
    // 解绑事件
    document.removeEventListener('visibilitychange', hideChangeListener);
    document.removeEventListener('onbeforeunload ', closeChangeListener);
    next();
  } else if (fromPrimaryPath === 'main' && toPrimaryPath === 'main') {
    // 群组跳转更新gid,cid
    getGidAndCid();
    next();
  } else {
    next();
  }
}
// 监听隐藏显示时的事件
function hideChangeListener() {
  if (document.hidden || isBlur) {
    if (isHidden) return;
    // 页面隐藏关闭计时并上报
    clearInterval(Number(openTimer));
    onReportOpenHandler(cid, gid);
    isHidden = true;
  } else {
    if (!isHidden) return;
    // 页面显示重新计时
    startTime = Date.now();
    openTimer = setInterval(() => {
      onReportOpenHandler(cid, gid);
    }, 10000);
    isHidden = false;
  }
}
// 监听关闭时的事件
function closeChangeListener() {
  clearInterval(Number(allTimer));
  clearInterval(Number(openTimer));
  onReportAllHandler(cid, gid);
}
// 上报展示时长数据
function onReportOpenHandler(channelId: string, groupId: string) {
  if (startTime === 0) return;
  if (groupId === '0' || channelId === '0') {
    getGidAndCid();
  }
  const time = Date.now() - startTime;
  report({
    reportParamsList: [{
      operId: '1900000110301',
      groupId: gid,
      channelId: cid || '0',
      duration: `${(time / 1000).toFixed(0)}`,
    }],
  });
  startTime = Date.now();
}
// 上报总共时长数据
function onReportAllHandler(channelId: string, groupId: string) {
  if (allStartTime === 0) return;
  if (groupId === '0' || channelId === '0') {
    getGidAndCid();
  }
  const time = Date.now() - allStartTime;
  report({
    reportParamsList: [{
      operId: '1900000110302',
      groupId: gid,
      channelId: cid || '0',
      duration: `${(time / 1000).toFixed(0)}`,
    }],
  });
  allStartTime = Date.now();
}
// 获取gid与cid
function getGidAndCid() {
  const rootState = (store.state as AllModuleState);
  cid = rootState.group.selectChannelId ? rootState.group.selectChannelId : '0';
  gid = rootState.group.selectGroupId ? rootState.group.selectGroupId : '0';
}


